import PropTypes from 'prop-types';
import React from 'react';
import {TrackingContext} from '@homeaway/react-event-tracking';

import './Info.less';

// eslint-disable-next-line complexity
export class Info extends React.Component {
    static contextType = TrackingContext;

    static propTypes = {
        family: PropTypes.shape({}),
        siteInfo: PropTypes.shape({})
    };

    clickHandler = (text) => {
        return () => {
            const field = {
                actionlocation: `footer.${text.replace(/\s/g, '').toLowerCase()}`
            };
            this.context.trigger('footer.link.click', field);
        };
    };
    // eslint-disable-next-line complexity
    render() {
        if (!this.props.siteInfo && !this.props.family) {
            return null;
        }
        return (
            <div className="SiteFooter__info">
                {this.props.siteInfo &&
                <div>
                    <h3>{this.props.siteInfo.title}</h3>
                    {this.props.siteInfo.userLinks &&
                    <ul className="list-unstyled">
                        {this.props.siteInfo.userLinks.map((link, index) => (
                            <li key={index}>
                                <a href={link.link} target="_blank" rel="noopener" onClick={this.clickHandler(link.text)}>{link.text}</a>
                            </li>
                        ))}
                    </ul>
                    }
                    <h3>{this.props.siteInfo.companyTitle}</h3>
                    {this.props.siteInfo.companyLinks &&
                    <ul className="list-unstyled">
                        {this.props.siteInfo.companyLinks.map((link, index) => (
                            <li key={index}>
                                <a href={link.link} target="_blank" rel="noopener" onClick={this.clickHandler(link.text)}>{link.text}</a>
                            </li>
                        ))}
                    </ul>
                    }
                </div>
                }
                {this.props.family && this.props.family.sites &&
                <div className="SiteFooter__info__family">
                    <h3>{this.props.family.title}</h3>
                    <ul className="list-unstyled">
                        {this.props.family.sites.map((link, index) => (
                            <li key={index}>
                                <a href={link.link} target="_blank" rel="noopener" onClick={this.clickHandler(link.text)}>{link.text}</a>
                            </li>
                        ))}
                    </ul>
                </div>
                }
            </div>
        );
    }
}

export default Info;
